// Global banner shown when the API client gives up trying to refresh
// the access token. Listens for SESSION_EXPIRED_EVENT and offers a
// one-click "Sign in again" so the user doesn't have to navigate
// anywhere. Mounted once at the shell level.

import { useEffect, useState } from 'react';
import { SESSION_EXPIRED_EVENT } from '../api.js';
import { useAuth } from '../auth.js';

export function SessionExpiredBanner() {
  const { signIn } = useAuth();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    function onExpired() {
      setVisible(true);
    }
    window.addEventListener(SESSION_EXPIRED_EVENT, onExpired);
    return () => window.removeEventListener(SESSION_EXPIRED_EVENT, onExpired);
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed top-0 inset-x-0 z-40 flex justify-center px-3 pt-3 pointer-events-none">
      <div className="pointer-events-auto surface border border-amber-300 dark:border-amber-700 rounded-lg shadow-lg px-3 py-2 flex items-center gap-3 text-sm max-w-md w-full">
        <span className="inline-flex h-6 w-6 items-center justify-center rounded-full bg-amber-100 dark:bg-amber-900/40 text-amber-700 dark:text-amber-300 shrink-0">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
            <path d="M12 8v4M12 16h.01" />
            <circle cx="12" cy="12" r="10" />
          </svg>
        </span>
        <p className="flex-1 text-strong">Your session expired.</p>
        <button
          type="button"
          onClick={() => {
            setVisible(false);
            signIn();
          }}
          className="btn-primary px-3 py-1 text-xs font-medium"
        >
          Sign in again
        </button>
        <button
          type="button"
          onClick={() => setVisible(false)}
          className="text-faint hover:text-mid"
          aria-label="Dismiss"
          title="Dismiss"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>
    </div>
  );
}
